import './rich-text/plugins/formula/load-mathjax';

import { createRoot } from 'react-dom/client';

import App from './app';
import StaticScreen from './app/StaticScreen';
import { getActiveSlideId, getOrCreatePresentationId, resizeAddin, setHasMetadataOnBackend } from './db/ppt';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';
import Logger from './utils/logger';

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById('container');
const root = rootElement ? createRoot(rootElement) : undefined;

Office.initialize = (reason) => {
  Logger.info(`Initialization Reason: ${reason}`);
};

/* Render application after Office initializes */
Office.onReady(() => {
  PowerPoint.run(async function (context) {
    try {
      const { presentationId, isNewPresentation } = await getOrCreatePresentationId();

      if (isNewPresentation) {
        await setHasMetadataOnBackend(false);
      }

      const activeSlideId = await getActiveSlideId();

      await resizeAddin();

      const handleError = (error: Error) => {
        Logger.error(error);
      };

      root?.render(
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
          <App
            presentationId={presentationId}
            isNewPresentation={isNewPresentation}
            activeSlideId={activeSlideId!}
          />
        </ErrorBoundary>
      );
    } catch (error) {
      Logger.error(error);
    }
  });

  root?.render(<StaticScreen />);
});

if ((module as any).hot) {
  (module as any).hot.accept('./app', () => {
    const NextApp = require('./app').default;
    root?.render(NextApp);
  });
}
